import { render, staticRenderFns } from "./DisclosureIconWithText.vue?vue&type=template&id=878c47e2"
import script from "./DisclosureIconWithText.vue?vue&type=script&lang=ts"
export * from "./DisclosureIconWithText.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports